import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { Button, Divider, Grid, IconButton } from '@mui/material';
import { drawerRoute } from '../Data/Data'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import '../Fonts/Kanit.css'
import '../Fonts/Fjalla.css'
import logo from '../Assests/billLogo.png'
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import UserLogin from './UserLogin';
import UserSignUp from './UserSignUp';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import WarningIcon from '@mui/icons-material/Warning';
import { BRAND } from '../constants/brand';


export default function Navbar() {
  const DRAWER_WIDTH = 310;
  const navigate = useNavigate();
  const location = useLocation();
  const normalizedPath = (location?.pathname || '').toLowerCase();
  const useCompactNav =
    normalizedPath.startsWith('/billing');
  const [state, setState] = React.useState({
    left: false,
  });

  const [openDialog, setOpenDialog] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [iconChange, setIconChange] = React.useState(false)
  const [handleOpen, setHandleOpen] = React.useState(false);
  const [handleOpenSign, setHandleOpenSign] = React.useState(false);
  const [isLoggedIn, setIsLoggedIn] = React.useState(false);

  const token = sessionStorage.getItem('token');
  // const username = sessionStorage.getItem('username');
  const role = sessionStorage.getItem('role');
  const [username, setUsername] = React.useState('');

  React.useEffect(() => {
    // const username = sessionStorage.getItem('username'); // Or sessionStorage.getItem('username');

    // if (username) {
    //   setUsername(username);
    //   setIsLoggedIn(true);  // Set isLoggedIn to true if username exists
    // } else {
    //   setIsLoggedIn(false); // Ensure isLoggedIn is false if there's no username
    // }
    const storedPaws = JSON.parse(sessionStorage.getItem(BRAND.sessionStorageKey));

    if (storedPaws && storedPaws.username) {
      setUsername(storedPaws.username); // Set username from the stored 'paws' object
      setIsLoggedIn(true);  // Set isLoggedIn to true if username exists
    } else {
      setIsLoggedIn(false); // Set isLoggedIn to false if there's no username
    }
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem(BRAND.sessionStorageKey);
    sessionStorage.removeItem('username');
    sessionStorage.removeItem('role');

    sessionStorage.clear(); // Clear session storage (or sessionStorage.clear() if using sessionStorage)
    window.location.reload();
  };

  const handleLogoutClick = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = (confirm) => {
    setOpenDialog(false);
    if (confirm) {
      handleLogout();
    }
  };

  function userLogin() {
    setHandleOpen(true);
  }
  function userSign() {
    setHandleOpenSign(true)
  }

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({
      ...state,
      [anchor]: open
    });

    setOpen(true)
  };

  const toggleDrawerClose = (anchor, close) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({
      ...state,
      [anchor]: close
    });
    setOpen(false)

  };

  const toggleDrawerOnClick = (anchor, close) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({
      ...state,
      [anchor]: close
    });
    setOpen(false)
    setIconChange(false)
  };

  const handleClick = () => {
    navigate("Login")
  }
  const handleClickLogout = () => {

    const result = window.confirm("Are you sure?");

    if (result) {
      //console.log("User clicked OK");
      sessionStorage.clear()
      window.location.reload()
      navigate("Login")
    }

  }

  const list = (anchor) => (
    <Box
      sx={{
        width: DRAWER_WIDTH,
        background: '#ffffffff',
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
      role="presentation"
      onKeyDown={toggleDrawerOnClick(anchor, false)}
    >
        {username ? (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', pr: 1, pt: 1 }}>
          <IconButton aria-label="menu close" onClick={toggleDrawerClose(anchor, false)}>
            <MenuOpenIcon sx={{ color: '#071418', fontSize: '32px' }} />
          </IconButton>
        </Box>

        ) :<>
        </>}
      <center>
        <a href='/'>

        <img
          src={logo}
          height='80px'
          alt='Avotas Auto Zone'
          draggable={false}
          />
          </a>
      </center>
      <Divider />

      {/* menu list view start */}
      <List
        sx={{
          flexGrow: 1,
          overflowY: 'auto',
        }}>
        {drawerRoute.map((text, index) => (
          <ListItem key={index} disablePadding>
            <Link
              to={text.path}
              onClick={toggleDrawerOnClick(anchor, false)}
              style={{
                textDecoration: 'none',
                color: 'black',
                width: '100%',
              }}
            >
              <ListItemButton sx={{ width: '100%' }}>
                <ListItemIcon sx={{ color: 'black' }}>
                  {text.icon}
                </ListItemIcon>
                <ListItemText
                  primaryTypographyProps={{
                    color: 'black',
                    fontWeight: 'bold',
                    fontFamily: 'Kanit, sans-serif'
                  }}
                  primary={text.name}
                />
              </ListItemButton>
            </Link>
          </ListItem>
        ))}
      </List>
      {/* menu list view end */}
      {isLoggedIn ? (
        <Box sx={{ p: 2, borderTop: '1px solid #e0e0e0' }}>
          <Button
            fullWidth
            variant="contained"
            onClick={handleLogoutClick}
            startIcon={<LogoutIcon />}
            sx={{
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 'bold',
              backgroundColor: '#071418',
              color: 'white',
              py: 1.2,
              '&:hover': {
                backgroundColor: '#000',
              },
            }}
          >
            Logout | {username}
          </Button>
        </Box>
      ) : null}

    </Box>
  );


  return (
    <div >
      {['left'].map((anchor) => (
        <React.Fragment key={anchor}>
          {useCompactNav ? (
            username ? (!state[anchor] ? (
              <IconButton
                aria-label="menu open"
                onClick={toggleDrawer(anchor, true)}
                sx={{
                  position: 'fixed',
                  top: '50%',
                  left: 0,
                  transform: 'translate(-25%, -50%)',
                  zIndex: 1201,
                  backgroundColor: '#ffffff',
                  border: '1px solid #d9d9d9',
                  borderLeft: 'none',
                  borderRadius: '0 10px 10px 0',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                  width: 44,
                  height: 64,
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                  },
                }}
              >
                <MenuIcon sx={{ color: '#071418', fontSize: '30px' }} />
              </IconButton>
            ) : null) : (
              <Button
                size="small"
                variant="contained"
                sx={{
                  position: 'fixed',
                  top: 10,
                  right: 10,
                  zIndex: 1201,
                  borderRadius: '8px',
                  textTransform: 'none',
                  color: 'black',
                  backgroundColor: 'white',
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                  },
                }}
                startIcon={<AccountCircleIcon style={{ color: 'black' }} />}
                onClick={userLogin}
              >
                Login
              </Button>
            )
          ) : (
            <Box
              sx={{
                background: '#071418',
                position: 'fixed',
                width: '100%',
                zIndex: 1,
                overflow: 'hidden',
                padding: isLoggedIn ? 0 : '10px 0px',
              }}
            >
              <Grid container spacing={2}>
                <Grid item md={6} xs={6}>
                  {username ? (
                    <IconButton aria-label="menu open">
                      <MenuIcon onClick={toggleDrawer(anchor, true)} sx={{ color: 'white', fontSize: '40px' }} />
                    </IconButton>
                  ) : <></>}
                </Grid>
                <Grid item md={6} xs={6} sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', paddingRight: '1vw', marginTop: 1 }}>
                  <Button
                    size="small"
                    variant="contained"
                    sx={{
                      width: '250px',
                      borderRadius: '8px',
                      padding: '10px 30px',
                      textTransform: 'none',
                      color: 'black',
                      transition: 'background-color 0.3s ease',
                      backgroundColor: 'white',
                      '&:hover': {
                        backgroundColor: isLoggedIn ? '#EA001D' : 'white',
                      },
                    }}
                    startIcon={<AccountCircleIcon style={{ color: 'black' }} />}
                    onClick={() => {
                      isLoggedIn ? handleLogoutClick() : userLogin();
                    }}
                  >
                    {isLoggedIn ? (
                      <span style={{ color: 'black', fontWeight: 'bold' }}>Logout | {username}</span>
                    ) : (
                      <span style={{ color: 'black', fontWeight: 'bold' }}>Login</span>
                    )}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          )}
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawerOnClick(anchor, false)}
            PaperProps={{ sx: { width: DRAWER_WIDTH } }}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))
      }
      <UserLogin setHandleOpen={setHandleOpen} handelOpen={handleOpen} />
      <UserSignUp setHandleOpen={setHandleOpenSign} handelOpen={handleOpenSign} />

      {/* Confirmation Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle
          style={{
            backgroundColor: 'black',
            color: 'white',
            fontWeight: 'bold',
            fontSize: '1.5rem',
            textAlign: 'center',
            padding: '16px',
          }}
        >
          <WarningIcon style={{ fontSize: 30, marginRight: 10 }} />
          Are you sure you want to log out?
        </DialogTitle>

        <DialogActions style={{ justifyContent: 'center', padding: '16px' }}>
          <Button
            onClick={() => handleCloseDialog(false)}
            style={{
              fontWeight: 'bold',
              textTransform: 'none',
              borderRadius: '8px',
              padding: '10px 20px',
              backgroundColor: '#BDBDBD',
              color: 'white',
              marginRight: '10px',
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleCloseDialog(true)}
            style={{
              fontWeight: 'bold',
              textTransform: 'none',
              borderRadius: '8px',
              padding: '10px 20px',
              backgroundColor: '#D32F2F',
              color: 'white',
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>


      <UserLogin
        setHandleOpen={setHandleOpen}
        handelOpen={handleOpen}
      />
      <UserSignUp
        setHandleOpen={setHandleOpenSign}
        handelOpen={handleOpenSign}
      />
    </div >
  )
}
